import React from 'react';
import { Layouts } from 'components';

export default function HomeView({ theme }) {
    return (
        <Layouts.HomeLayout theme={theme}>
        </Layouts.HomeLayout>
    );
}
